module.exports = __webpack_public_path__ + "img/lg_ring_r_o_1_0@2x.748c9540.png";